export default __webpack_public_path__ + "static/media/James.9be5603e.png";